/*
*Ф-ция, которая возвращает правильные настройки для API в зависимости
*от URL на котором была открыта страница приложения
*Для новых проектов надо редактировать variants и возможно defaultSettings
*/

const apiUrlDetector=(url='')=>{

    //Объект который будет возвращен по умолчанию.
    //
    //Смысл полей
    // apiHost - адрес по которому у нас отвечает API
    // apiPort - номер порта на котором API отвечает
    // apiMethod - метод по которому отпавляются запросы ('GET' || 'POST')
    // apiPath - префикс адреса апи (например /api/v1/)
    // apiSuffix - суффикс запроса (добавляется в конце запроса, после адреса точки api)
    // siteUrl - то что считается корнем сайта. Иногда это бывает нужно, и исторически это лежит в ApiService
    // envType - тип окружения (нужно например для определения уровня вывода ошибок
    // 'DEV' || 'DEV-DUMMY' || 'TEST' || 'TEST-DUMMY' || 'PROD')
    //
    const defaultSettings = {
      apiHost:'http://localhost',
      apiPort:'3000',
      apiMethod:'GET',
      apiPath:'/test-json/',
      apiSuffix:'.json',
      siteUrl:"http://localhost:3000",
      envType: 'DEV'
    };
  
    //Массив объектов с настройками для разных вариантов url
    //при вызове ф-ции мы пробегаем по нему и сравниваем поля fs
    //с соответствующим по длине куском адресной строки. Если найдено совпадение -
    //возвращаем этот объект settings этого элемента. Если совпадений не найдено
    //возвращаем объект defaultSettings. Синтатксис объектос settings совпадает с
    //синтакстисом объекта defaultSettings
    //
    const variants = [
      {
        //Боевой сервер (Облачный) с использованем реального апи (Облачного)
        //источник данных - боевое апи.
        fs:"http://cloud.elpat.online",
        settings:{
          apiHost:'http://cloud.elpat.online',
          apiPort:'8080',
          apiMethod:'POST',
          apiPath:'/api/v1/',
          apiSuffix:'',
          siteUrl:"http://cloud.elpat.online",
          envType: 'PROD'
        }
      },
      {
        // https
        //Боевой сервер (Облачный) с использованем реального апи (Облачного)
        //источник данных - боевое апи.
        fs:"https://cloud.elpat.online",
        settings:{
          apiHost:'https://cloud.elpat.online',
          apiPort:'8080',
          apiMethod:'POST',
          apiPath:'/api/v1/',
          apiSuffix:'',
          siteUrl:"https://cloud.elpat.online",
          envType: 'PROD'
        }
      },
      {
        //Боевой сервер (новый) с использованем реального апи (нового)
        //источник данных - боевое апи.
        fs:"http://elpat.online",
        settings:{
          apiHost:'http://back.elpat.online',
          apiPort:'',
          apiMethod:'POST',
          apiPath:'/api/v1/',
          apiSuffix:'',
          siteUrl:"http://elpat.online",
          envType: 'PROD'
        }
      },
      {
        // https
        //Боевой сервер (новый) с использованем реального апи (нового)
        //источник данных - боевое апи.
        fs:"https://elpat.online",
        settings:{
          apiHost:'https://back.elpat.online',
          apiPort:'',
          apiMethod:'POST',
          apiPath:'/api/v1/',
          apiSuffix:'',
          siteUrl:"https://elpat.online",
          envType: 'PROD'
        }
      },
      // {
      //   //Когда с дева надо подрубится к продуктовому апи
      //   //источник данных - боевое апи.
      //   fs:"http://localhost:3001",
      //   settings:{
      //     apiHost:'http://back.elpat.online',
      //     apiPort:'',
      //     apiMethod:'POST',
      //     apiPath:'/api/v1/',
      //     apiSuffix:'',
      //     siteUrl:"http://localhost:3030",
      //     envType: 'DEV'
      //   }
      // },
      {
        //Тестовый сервер (новый) с использованем тестового апи (нового)
        //источник данных - тестовое апи.
        fs:"http://dev.elpat.online",
        settings:{
          apiHost:'http://dev.elpat.online',
          apiPort:'8080',
          apiMethod:'POST',
          apiPath:'/api/v1/',
          apiSuffix:'',
          siteUrl:"http://dev.elpat.online",
          envType: 'TEST'
        }
      },
      {
        // https
        //Тестовый сервер (новый) с использованем тестового апи (нового)
        //источник данных - тестовое апи.
        fs:"https://dev.elpat.online",
        settings:{
          apiHost:'https://dev.elpat.online',
          apiPort:'8080',
          apiMethod:'POST',
          apiPath:'/api/v1/',
          apiSuffix:'',
          siteUrl:"https://dev.elpat.online",
          envType: 'TEST'
        }
      },
      {
        //Локальное обращение к девелоперской машине
        //источник данных - боевое апи
        fs:"http://localhost:3000",
        settings:{
          apiHost:'http://dev.elpat.online',
          apiPort:'8080',
          apiMethod:'POST',
          apiPath:'/api/v1/',
          apiSuffix:'',
          siteUrl:"http://localhost:3000",
          envType: 'DEV'
        }
      },
      {
        // Стенд ГСК на яндексе
        // источник данных - боевое апи
        fs:"https://front-test.itst-gsk.ru",
        settings:{
          apiHost:'https://back.itst-gsk.ru',
          apiPort:'443',
          apiMethod:'POST',
          apiPath:'/api/v1/',
          apiSuffix:'',
          siteUrl:"https://front-test.itst-gsk.ru",
          envType: 'PROD'
        }
      },


      // {
      //   //Локальное обращение к девелоперской машине запущенной на спец. порту
      //   //источник данных - dummy апи
      //   fs:"http://localhost:3001",
      //   settings:{
      //     apiHost:'http://localhost',
      //     apiPort:'3001',
      //     apiMethod:'GET',
      //     apiPath:'/test-json/',
      //     apiSuffix:'.json',
      //     siteUrl:"http://localhost:3001",
      //     envType: 'DEV-DUMMY'
      //   }
      // },
      // {
      //   //Сетевое обращение к девелоперской машине запущенной на спец. порту
      //   //источник данных - dummy апи
      //   fs:"http://192.172.1.16:3001",
      //   settings:{
      //     apiHost:'http://192.172.1.16',
      //     apiPort:'3001',
      //     apiMethod:'GET',
      //     apiPath:'/test-json/',
      //     apiSuffix:'.json',
      //     siteUrl:"http://192.172.1.16:3001",
      //     envType: 'DEV-DUMMY'
      //   }
      // },
    ];
    //Ищем совпадение адресной строки
    for(let item of variants){
      const { fs = '' } = item;
      //... и если находим - возвращаем объект settings
      if(url.substring(0,fs.length).toLowerCase()===fs.toLowerCase()) return item.settings;
    }
    //..., а если не находим - возвращаем defaultSettings
    return defaultSettings;
  }
  
  export default apiUrlDetector;